import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  retireeNewsletterDetails: {},
  retireeNewsletter: null,
  retireeNewsletterError: null,
};

export const retireeNewsletterSlice = createSlice({
  name: "retireeNewsletter",
  initialState,
  reducers: {
    setRetireeNewsletterDetail: (state, action) => {
      state.retireeNewsletterDetails = action.payload;
      state.retireeNewsletterError = null;
    },
    setRetireeNewsletter: (state, action) => {
      state.retireeNewsletter = action.payload.data;
      state.retireeNewsletterError = null;
    },
    setRetireeNewsletterError: (state, action) => {
      state.retireeNewsletterError = action.payload.error;
    },
  },
});

export const { setRetireeNewsletterDetail, setRetireeNewsletter, setRetireeNewsletterError } = retireeNewsletterSlice.actions;

export default retireeNewsletterSlice.reducer;